export const vHungryEmail = {
  email: [
    {
      type: 'regex',
      pattern: /^[a-z0-9](.?[a-z0-9]){2,}@?tryhungry.com$/i,
      message: 'not a valid HUNGRY email or distribution',
    },
  ],
}
